import ReactGA from "react-ga4";
import { AppModulesType, GAEventParam, ResourceType } from "../types";
import { GA_EVENTS } from "../config";

type GAEventsName = typeof GA_EVENTS[number];

export const GAHelper = {
    setAccess: (afore: string, user?: string) => {
        registerCustomGAEventBySession('event_access', { app_afore: afore }, user)
    },
    setArtifactView: (module: AppModulesType, resource: ResourceType, afore?: string, user?: string) => {
        registerCustomGAEvent('event_artifact', {
            app_afore: afore,
            app_module: module,
            app_artifact_file: resource.name
        }, user)
    },
    setRestServiceView: (group: string, apiName: string, afore?: string, user?: string) => {
        registerCustomGAEvent('event_rest_service', {
            app_afore: afore,
            app_group: group,
            app_artifact: apiName
        }, user)
    },
    setEnvRequest: (group: string, afore?: string, user?: string) => {
        registerCustomGAEvent('event_env_request', {
            app_afore: afore,
            app_group: group,
        }, user)
    },
    setEnvResponse: (group: string, afore?: string, user?: string) => {
        registerCustomGAEvent('event_env_response', {
            app_afore: afore,
            app_group: group,
        }, user)
    },
    setFrontReject: (responseText: string, stack: string) => {
        registerCustomGAEvent('event_reject', {
            app_level: 'Front',
            app_response_text: responseText,
            app_stack: stack
        })
    },
    setServiceReject: (responseText: string, urlService: string, user?: string) => {
        registerCustomGAEvent('event_reject', {
            app_level: 'Service',
            app_response_text: responseText,
            app_url: urlService
        }, user)
    },

    cleanSession: () => {
        GA_EVENTS.forEach(gaEvent => sessionStorage.removeItem(gaEvent))
        sessionStorage.removeItem("gaUserId")
    }
}


function registerCustomGAEventBySession(eventName: GAEventsName, params: GAEventParam, user?: string) {
    let existEvent = sessionStorage.getItem(eventName)
    if (!existEvent) {
        registerCustomGAEvent(eventName, params, user)
        sessionStorage.setItem(eventName, "true")
    }
}

function registerCustomGAEvent(eventName: GAEventsName, params: GAEventParam, user?: string) {
    try {
        let gaUserId = sessionStorage.getItem("gaUserId")
        if (!gaUserId && user) {
            gaUserId = Array.from(user).reverse().slice(0, 14).join("")
            sessionStorage.setItem("gaUserId", gaUserId)
        }
        params.user_id = gaUserId
        params.app_version = process.env.REACT_APP_VERSION
        ReactGA.event(eventName, params)
    } catch (e) {
        console.log(e)
    }
}